import {Effect} from 'effect';

import {PollingConfig, PollingService} from 'services/Effect/Polling';

export async function runPollingEffect<R extends {status: string; progressPercent?: number}>(
  config: PollingConfig<R>,
): Promise<R> {
  const pollingService = Effect.gen(function* () {
    const service = yield* PollingService;
    // Pass all original config properties along with empty callback handlers
    const result = yield* service.poll(config);
    return result;
  });

  return Effect.runPromise(Effect.provide(pollingService, PollingService.Default));
}
